import { useEffect } from 'react'
import { useWarnAboutChange } from '@refinedev/core'
import { useLocation } from 'react-router-dom'

import { usePrompt } from '@/hooks/use-unsaved-changes-prompt'

interface UnsavedChangesNotifierProps {
	message?: string
}

export function UnsavedChangesNotifier({
	message = 'Are you sure you want to leave? You have unsaved changes.',
}: UnsavedChangesNotifierProps) {
	const { pathname } = useLocation()
	const { warnWhen, setWarnWhen } = useWarnAboutChange()

	useEffect(() => {
		return () => {
			setWarnWhen?.(false)
		}
	}, [pathname, setWarnWhen])

	usePrompt(message, warnWhen)

	return null
}
